import { Loader } from "@mantine/core";
import { clsx } from "clsx";
import { useLoaderStore } from "./useLoader.hook";

interface CircleLoaderProps {
  className?: string;
  isLoading?: boolean;
}

const CircleLoader = ({ className, isLoading }: CircleLoaderProps) => {
  const loaderStore = useLoaderStore();

  if (!loaderStore.isLoadingBySkeleton() && !isLoading) return null;

  return (
    <div
      className={clsx(
        "absolute top-0 left-0 flex w-full justify-center p-[10%]",
        className,
      )}
    >
      <Loader />
    </div>
  );
};

export default CircleLoader;
